/* ==========================================================
   Don Chacho 2.0 — Mayoreo (v3, sin login)
   Tienda: selector de tamaño, cajas, armador de caja personalizada
   y barra del pedido con el carrito real.
   Distribuidores: regresa la vista al mensaje después de enviar.
   Usa los hooks del cart drawer si existen:
   window.dcRefreshCart() y window.dcOpenCart()
   ========================================================== */
(function () {
  function dinero(centavos) {
    var cifra = centavos / 100;
    return '$' + cifra.toLocaleString('es-MX', { minimumFractionDigits: cifra % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function reemplazar(texto, valores) {
    return Object.keys(valores).reduce(function (t, k) {
      return t.split('[' + k + ']').join(valores[k]);
    }, texto || '');
  }

  /* ---------------- Tienda ---------------- */
  function iniciarTienda(root) {
    if (!root || root.dataset.dcInit === '1') return;
    root.dataset.dcInit = '1';

    var d = root.dataset;
    var cartUrl = d.cartUrl || '/cart';
    var addUrl = d.cartAddUrl || '/cart/add';
    var envio = parseInt(d.envio || '0', 10);
    var u1 = parseInt(d.u1 || '3', 10);
    var p1 = parseFloat(d.p1 || '0');
    var u2 = parseInt(d.u2 || '7', 10);
    var p2 = parseFloat(d.p2 || '0');
    var aviso = root.querySelector('[data-dc-aviso]');

    // Variantes de mayoreo que hay en esta página (cajas + personalizadas)
    var ids = {};
    root.querySelectorAll('form input[name="id"]').forEach(function (i) {
      ids[String(i.value)] = true;
    });

    function mostrarAviso(texto) {
      if (!aviso) return;
      aviso.textContent = texto;
      aviso.hidden = false;
    }

    function ocultarAviso() {
      if (aviso) aviso.hidden = true;
    }

    function leerCarrito() {
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    function set(sel, texto) {
      var el = root.querySelector(sel);
      if (el) el.textContent = texto;
    }

    function pintar(cart) {
      var n = 0;
      var sub = 0;
      var mixto = false;
      (cart.items || []).forEach(function (item) {
        if (ids[String(item.variant_id)]) {
          n += item.quantity;
          sub += item.original_line_price;
        } else {
          mixto = true;
        }
      });

      var nivel = n >= u2 ? 2 : n >= u1 ? 1 : 0;
      var pct = nivel === 2 ? p2 : nivel === 1 ? p1 : 0;
      var desc = Math.round((sub * pct) / 100);

      // Niveles
      root.querySelectorAll('[data-nivel]').forEach(function (el) {
        var activo = n > 0 && parseInt(el.dataset.nivel, 10) === nivel;
        el.dataset.activo = activo ? 'true' : 'false';
        var estado = el.querySelector('[data-estado]');
        if (estado) estado.textContent = activo ? d.txtAqui : '';
      });

      // Barra
      var vacio = root.querySelector('[data-dc-vacio]');
      var lleno = root.querySelector('[data-dc-lleno]');
      var totalWrap = root.querySelector('[data-dc-total-wrap]');
      var mixtoEl = root.querySelector('[data-dc-mixto]');

      if (vacio) vacio.hidden = n > 0;
      if (lleno) lleno.hidden = n === 0;
      if (totalWrap) totalWrap.hidden = n === 0;

      set('[data-dc-bar-count]', n + ' ' + (n === 1 ? d.txtCaja : d.txtCajas));
      set('[data-dc-subtotal]', dinero(sub));
      set('[data-dc-desc]', pct ? pct + '% (−' + dinero(desc) + ')' : '—');
      set('[data-dc-total]', dinero(sub - desc + envio));

      var pista;
      if (n < u1) pista = reemplazar(d.pista1, { n: u1 - n, pct: p1 });
      else if (n < u2) pista = reemplazar(d.pista2, { pct: p1, n: u2 - n, pct2: p2 });
      else pista = reemplazar(d.pista3, { pct: p2 });
      set('[data-dc-pista]', pista);

      if (mixtoEl) mixtoEl.hidden = !(mixto && n > 0);
    }

    function refrescar() {
      if (typeof window.dcRefreshCart === 'function') window.dcRefreshCart();
      return leerCarrito().then(pintar);
    }

    function agregar(form) {
      return fetch(addUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
          return data;
        });
      });
    }

    function confirmarBoton(boton, textoFinal) {
      boton.textContent = d.txtAgregado;
      setTimeout(function () {
        boton.textContent = textoFinal;
      }, 1600);
    }

    // Selector de tamaño
    var botonesTamano = root.querySelectorAll('[data-dc-size]');
    botonesTamano.forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.dataset.size = btn.dataset.dcSize;
        botonesTamano.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });

    // Cantidad en cajas de un sabor
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dc-qty]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      var valor = parseInt(input.value, 10) || 1;
      input.value = Math.min(99, Math.max(1, valor + parseInt(btn.dataset.dcQty, 10)));
    });

    // Agregar cajas de un sabor
    root.querySelectorAll('[data-dc-caja]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation(); // el carrito también escucha /cart/add y lo agregaría dos veces
        var boton = form.querySelector('.dc-may-btn-agregar');
        var original = boton.textContent;
        boton.disabled = true;
        ocultarAviso();
        agregar(form)
          .then(function () {
            form.querySelector('input[name="quantity"]').value = 1;
            confirmarBoton(boton, original);
            return refrescar();
          })
          .catch(function (err) {
            mostrarAviso(err.message);
          })
          .finally(function () {
            boton.disabled = false;
          });
      });
    });

    // Armadores de caja personalizada (uno por tamaño)
    root.querySelectorAll('[data-dc-armador]').forEach(function (form) {
      var max = parseInt(form.dataset.max || '12', 10);
      var filas = form.querySelectorAll('[data-sabor]');
      var input = form.querySelector('[data-dc-armado-input]');
      var boton = form.querySelector('[data-dc-armado-btn]');
      var conteo = {};

      function total() {
        return Object.keys(conteo).reduce(function (a, k) {
          return a + conteo[k];
        }, 0);
      }

      function actualizar() {
        var t = total();
        var partes = [];
        filas.forEach(function (fila) {
          var nombre = fila.dataset.sabor;
          var c = conteo[nombre] || 0;
          fila.querySelector('[data-dc-count]').textContent = c;
          if (c > 0) partes.push(nombre + ' × ' + c);
        });
        form.querySelector('[data-dc-armado-count]').textContent = t;
        form.querySelector('[data-dc-armado-barra]').style.width = Math.round((t / max) * 100) + '%';
        form.querySelector('[data-dc-armado-lista]').textContent = partes.length ? partes.join(', ') : form.dataset.txtVacia;
        input.value = partes.join(', ');
        var listo = t === max;
        boton.disabled = !listo;
        boton.textContent = listo ? form.dataset.txtArmar : reemplazar(form.dataset.txtFaltan, { n: max - t });
      }

      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dc-delta]');
        if (!btn) return;
        var nombre = btn.closest('[data-sabor]').dataset.sabor;
        var delta = parseInt(btn.dataset.dcDelta, 10);
        var actual = conteo[nombre] || 0;
        if (delta > 0 && total() >= max) return;
        conteo[nombre] = Math.max(0, actual + delta);
        actualizar();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation(); // el carrito también escucha /cart/add y lo agregaría dos veces
        if (total() !== max) return;
        boton.disabled = true;
        ocultarAviso();
        agregar(form)
          .then(function () {
            conteo = {};
            actualizar();
            boton.textContent = d.txtAgregado;
            setTimeout(actualizar, 1600);
            return refrescar();
          })
          .catch(function (err) {
            mostrarAviso(err.message);
            boton.disabled = false;
          });
      });

      actualizar();
    });

    // "Ver carrito" abre el drawer si existe
    var verCarrito = root.querySelector('[data-dc-carrito]');
    if (verCarrito) {
      verCarrito.addEventListener('click', function (e) {
        if (typeof window.dcOpenCart === 'function') {
          e.preventDefault();
          window.dcOpenCart();
        }
      });
    }

    // Si el carrito cambia desde el drawer, actualiza la barra al volver a la página
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) leerCarrito().then(pintar).catch(function () {});
    });

    leerCarrito().then(pintar).catch(function () {});
  }

  /* ---------------- Distribuidores ---------------- */
  function iniciarDistribuidores(root) {
    if (!root || root.dataset.dcInit === '1') return;
    root.dataset.dcInit = '1';
    var mensaje = root.querySelector('.dc-may-dist__exito, .dc-may-dist__errores');
    if (mensaje) {
      setTimeout(function () {
        mensaje.scrollIntoView({ block: 'center' });
      }, 150);
    }
  }

  /* ---------------- Hero: beneficios que pasan solos (móvil) ---------------- */
  function iniciarBeneficios(lista) {
    if (!lista || lista.dataset.dcInit === '1') return;
    lista.dataset.dcInit = '1';

    var segundos = parseFloat(lista.dataset.dcAutoplay || '0');
    if (!segundos) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var movil = window.matchMedia('(max-width: 749px)');
    var timer = null;
    var pausa = null;

    function siguiente() {
      if (!movil.matches) return;
      var items = lista.children;
      if (!items.length) return;
      var paso = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
      var alFinal = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
      lista.scrollTo({ left: alFinal ? 0 : lista.scrollLeft + paso, behavior: 'smooth' });
    }

    function arrancarTimer() {
      detener();
      timer = setInterval(siguiente, segundos * 1000);
    }

    function detener() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Si la persona desliza con el dedo, se pausa un rato y luego sigue
    function pausar() {
      detener();
      if (pausa) clearTimeout(pausa);
      pausa = setTimeout(arrancarTimer, 6000);
    }

    lista.addEventListener('touchstart', pausar, { passive: true });
    lista.addEventListener('pointerdown', pausar);

    // Solo corre mientras el hero está en pantalla
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        if (entradas[0].isIntersecting) arrancarTimer();
        else detener();
      }).observe(lista);
    } else {
      arrancarTimer();
    }
  }

  function arrancar() {
    document.querySelectorAll('[data-dc-autoplay]').forEach(iniciarBeneficios);
    document.querySelectorAll('[data-dc-tienda]').forEach(iniciarTienda);
    document.querySelectorAll('[data-dc-dist]').forEach(iniciarDistribuidores);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    iniciarTienda(e.target.querySelector('[data-dc-tienda]'));
    iniciarDistribuidores(e.target.querySelector('[data-dc-dist]'));
    iniciarBeneficios(e.target.querySelector('[data-dc-autoplay]'));
  });
})();